import { render, staticRenderFns } from "./balprcTotalStyle.vue?vue&type=template&id=8e854092&scoped=true&"
import script from "./balprcTotalStyle.vue?vue&type=script&lang=js&"
export * from "./balprcTotalStyle.vue?vue&type=script&lang=js&"
import style0 from "./balprcTotalStyle.vue?vue&type=style&index=0&id=8e854092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e854092",
  null
  
)

export default component.exports